import { useState, useEffect } from "react";

// Collection of 30 curated sunrise/sunset images from Unsplash
const sunriseImages = [
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1920&q=80", // sunrise over mountains
  "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?auto=format&fit=crop&w=1920&q=80", // golden sunrise
  "https://images.unsplash.com/photo-1495616811223-4d98c6e9c869?auto=format&fit=crop&w=1920&q=80", // sunrise over lake
  "https://images.unsplash.com/photo-1560813962-ff3d8fcf59ba?auto=format&fit=crop&w=1920&q=80", // colorful sunrise
  "https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?auto=format&fit=crop&w=1920&q=80", // sunrise through clouds
  "https://images.unsplash.com/photo-1475924156734-496f6cac6ec1?auto=format&fit=crop&w=1920&q=80", // misty mountain sunrise
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1920&q=80", // beach sunset
  "https://images.unsplash.com/photo-1414609245224-afa02bfb3fda?auto=format&fit=crop&w=1920&q=80", // mountain sunset
  "https://images.unsplash.com/photo-1500964757637-c85e8a162699?auto=format&fit=crop&w=1920&q=80", // ocean sunset
  "https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?auto=format&fit=crop&w=1920&q=80", // beach silhouette sunset
  "https://images.unsplash.com/photo-1496614932623-0a3a9743552e?auto=format&fit=crop&w=1920&q=80", // orange sunset
  "https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?auto=format&fit=crop&w=1920&q=80", // beach silhouette sunset
  "https://images.unsplash.com/photo-1496614932623-0a3a9743552e?auto=format&fit=crop&w=1920&q=80", // orange sunset
  "https://images.unsplash.com/photo-1514241516423-6c0a5e031aa2?auto=format&fit=crop&w=1920&q=80", // sunset over mountains
  "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?auto=format&fit=crop&w=1920&q=80", // golden sunset
  "https://images.unsplash.com/photo-1510784722466-f2aa9c52fff6?auto=format&fit=crop&w=1920&q=80", // sunset over mountains
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1920&q=80", // sunset over mountains
  "https://images.unsplash.com/photo-1494548162494-384bba4ab999?auto=format&fit=crop&w=1920&q=80", // sunset over mountains
  "https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?auto=format&fit=crop&w=1920&q=80", // sunset over mountains
];

export const useBackgroundRotation = () => {
  const [currentBackground, setCurrentBackground] = useState("");

  // Function to get a random image
  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * sunriseImages.length);
    return sunriseImages[randomIndex];
  };

  // Load a random image only once at component mount
  useEffect(() => {
    // Initialize with a random image
    const randomImage = getRandomImage();

    // Preload the image
    const img = new Image();
    img.src = randomImage;
    img.onload = () => {
      setCurrentBackground(randomImage);
    };
  }, []); // Empty dependency array ensures this runs only once

  return {
    currentBackground,
    isTransitioning: false,
  };
};

export default useBackgroundRotation;
